<template>
    <multiselect
            v-bind="$attrs"
            :value="value"
            @input="$emit('input', $event)"
            :options="options"
            class="custom-multiselect"
            :searchable="false"
            :show-labels="false"
            :allow-empty="false"
            v-on="$listeners"
    >
        <template #caret>
            <div class="multiselect__select">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none"><path d="M6.2 9.3L11.9 1C12 0.9 12 0.8 12 0.7 11.9 0.6 11.8 0.6 11.7 0.6L0.3 0.6C0.2 0.6 0.1 0.6 0 0.7 0 0.8 0 0.8 0 0.9 0 0.9 0 1 0.1 1L5.8 9.3C5.8 9.4 5.9 9.4 6 9.4 6.1 9.4 6.2 9.4 6.2 9.3Z" fill="#A6A5A6"/></svg>
            </div>
        </template>
    </multiselect>
</template>

<script>
    export default {
        name: "CustomMultiselect",
        props: ['value', 'options'],
    }
</script>

<style scoped>

</style>